import React from 'react';
import './Jumbotron.css';

const Jumbotron = ({ children, className = '' }) => {
  return (
    <div className={`hero-section ${className}`}>
      <div className="hero-content">
        {children}
      </div>
    </div>
  );
};

export default Jumbotron;
